<template functional>
  <th
    class="dataset-th"
    :style="[props.column.pre_style]"
  >
    <!-- sortable -->
    <b-tooltip
      :label="props.column.desc"
      :active="!!props.column.desc"
      type="is-beige"
      position="is-bottom"
      class="is-block"
    >
      <div class="field dataset-checkbox" v-if="props.column.label === 'Choose'">
          <b-checkbox @input="(e) => $options.onCheckChange(props, listeners, e)"> </b-checkbox>
      </div>
      <a
        v-else-if="props.column.sortable"
        class="dataset-th-sortable-trigger is-unselectable is-text-truncate"
        @click="() => $options.onClick(props, listeners)"
      >
        <order-icon
          v-if="props.column.align === `R`"
          :column="props.column"
          :sort="props.sort"
          :loading="props.loading"
        />

        <span>{{ props.column.label }}</span>

        <order-icon
          v-if="props.column.align === `L`"
          :column="props.column"
          :sort="props.sort"
          :loading="props.loading"
        />
      </a>

      <template v-else>
        <span>{{ props.column.label }}</span>
      </template>
    </b-tooltip>
  </th>
</template>

<script>
export default {
  name: 'DatasetTh',
  props: {
    column: { type: Object, default: () => ({}) },
    sort: { type: Object, default: () => ({}) },
    loading: { type: Boolean, default: () => true },
    rows: {type: Array, default: () => []},
    checkedrows: {type: Array, default: () => []}
  },
  onClick: (props, listeners) => {
    const col = props.column
    // nothing to click if field is not sortable
    // skip if not clickable
    if (!col.sortable || !listeners.click) return false
    // switch order of field
    return listeners.click()
  },
  onCheckChange: (props, listeners, value) => {
    if(value){
      props.checkedrows.length = 0
      props.rows.forEach(row => {
        props.checkedrows.push(row)
      })
    }else{
      //props.checkedrows = []
      for(let i = props.checkedrows.length - 1; i >=0; i--){
        props.checkedrows.splice(i, 1)
      }
    }
  }
}
</script>

<style lang="scss">
.dataset-th-sortable-trigger {
  cursor: pointer;
  display: block;
  color: inherit;
  transition: background-color 0.1s linear;

  &:hover {
    background-color: #f7fafc;
  }
}

.dataset-th {
  padding: 0 !important;
  margin: 0;

  > span > span,
  > span > a {
    display: block;
    padding: 0.5em 0.75em;
  }
}
.dataset-checkbox{
  padding: 10px 0px 0px 10px;
}
</style>
